var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectHeaderLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8126 52.1035L37.5726 63.3435C31.2453 69.6708 30.8786 80.0213 37.1032 86.4613C43.5128 93.0861 54.1176 93.0813 60.5216 86.4616C64.3348 82.5252 65.6375 76.9547 64.578 71.8052C63.9361 68.6723 62.4093 65.7002 60.0521 63.343L48.8126 52.1035Z",
    fill: "#FFC832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0705 49.3613L34.8305 38.1213C28.5032 31.794 18.1527 31.4273 11.7128 37.6519C5.08794 44.0615 5.0927 54.6663 11.7124 61.0703C15.6488 64.8835 21.2193 66.1862 26.3688 65.1267C29.5017 64.4848 32.4738 62.958 34.8311 60.6008L46.0705 49.3613Z",
    fill: "#0096FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.361 46.0706L38.1209 34.8306C31.7936 28.5033 31.4269 18.1528 37.6516 11.7128C44.0611 5.088 54.6659 5.09277 61.0699 11.7124C64.8831 15.6489 66.1858 21.2193 65.1263 26.3689C64.4844 29.5017 62.9577 32.4738 60.6004 34.8311L49.361 46.0706Z",
    fill: "#FF3CA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectHeaderLeft);
export default __webpack_public_path__ + "static/media/connectHeaderLeft.e2001002bd780e01a5b17212990f36a7.svg";
export { ForwardRef as ReactComponent };